import axios from './axios';
import SETTINGS from '../settings'
export default {
    getClients(params, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/client`, {params}).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    }
}